import { $window } from '../global';
import { gridManager } from './blocks-grid';
class AccordionManager {
    $accordions;
    init() {
        this.$accordions = $('.js-Accordion');
        if (this.$accordions.length === 0)
            return;
        const $title = $('.js-Accordion .js-Accordion_Title');
        $title.off('click.AccordionManager');
        $title.on('click.AccordionManager', (e) => {
            const prefix = '.js-Accordion';
            const item = $(e.currentTarget);
            const container = item.closest(prefix);
            const itemIsActive = item.hasClass('Active');
            if (itemIsActive && !container.data('accordion-allow-close-all'))
                return;
            const titles = container.find(`${prefix}_Title`);
            let contents = container.find(`${prefix}_Content`);
            const itemContent = item.parent().find(`${prefix}_Content`);
            contents = itemIsActive ? contents : contents.not(itemContent);
            titles.removeClass('Active');
            contents.slideUp(400, () => {
                item.removeAttr('style');
            });
            if (itemIsActive)
                return;
            item.addClass('Active');
            itemContent.removeClass('Hidden').css({ display: 'none' }).slideDown();
        });
        this.resizeAccordionHeight();
        $window.off('resize.AccordionManager');
        $window.on('resize.AccordionManager', () => this.resizeAccordionHeight());
    }
    resizeAccordionHeight() {
        let anyHeightChanged = false;
        this.$accordions.each((_, elem) => {
            const $elem = $(elem);
            const fixedContents = $elem.find('.Accordion_Content-FixedHeight');
            if (!fixedContents.length)
                return;
            const previousHeight = fixedContents.height();
            let maxHeight = 0;
            fixedContents.removeAttr('style').each((_, contentElem) => {
                const hiddenContent = $(contentElem).closest('.js-Accordion_Content[style*="display: none"]');
                if (hiddenContent.length) {
                    hiddenContent.css('display', '');
                }
                const height = $(contentElem).height();
                if (height > maxHeight)
                    maxHeight = height;
                if (hiddenContent.length) {
                    hiddenContent.css('display', 'none');
                }
            });
            fixedContents.css('height', maxHeight);
            const newHeight = fixedContents.height();
            if (previousHeight !== newHeight) {
                anyHeightChanged = true;
            }
        });
        if (!anyHeightChanged)
            return;
        gridManager.queueResize(true);
    }
}
const accordionManager = new AccordionManager();
export { accordionManager };
